// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkbox_checkboxWrapper__amtWj","check":"checkbox_check__3seZp","label":"checkbox_label__HRl8k"};